import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderSubsectionCard from '../Common/OrderSubsectionCard';
import { AdditionalInformation } from './AddditionalInformation';
import { ShiftsTile } from './ShiftsTile';
import { useSelector } from 'react-redux';
import { selectPage3 } from '@AMIEWEB/NewOrder/Store/Order.selectors';

export const ScheduleSubSection = () => {
  const page3 = useSelector(selectPage3);
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ShiftsTile key={JSON.stringify(page3)}/>
      </Grid>
      <Grid item xs={12}>
        <OrderSubsectionCard
          icon={<KeyboardArrowDownIcon sx={{ color: theme => theme.palette.framework.system.doveGray }} />}
          title={t('order.newOrderCreation.tabs.additionalInformation')}
          children={<AdditionalInformation />}
        />
      </Grid>
    </Grid>
  );
};
